import { Camera, Settings, SpaceDashboard } from "@mui/icons-material";
import { BottomNavigation, BottomNavigationAction, Box, Button, IconButton, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./Navigation.css";
import { useData } from "store/DataProvider";
import { enqueueSnackbar } from "notistack";
import ScanMenu from "./ScanMenu";
import ScanComponent from "assets/icons/Scan";
import { useNetworkStatus } from "hooks/useNetworkStatus";

const NavigationtBar = () => {
	const theme = useTheme();
	const navigate = useNavigate();
	const data = useData();
	const location = useLocation();
	const [navigateTo, setNavigateTo] = React.useState(location.pathname || "/");
	const [openFooter, setOpenFooter] = React.useState(false);
	const { isOnline } = useNetworkStatus();
	const isMobile = useMediaQuery(theme.breakpoints.down("md"));

	const openFooterMenu = () => {
		const footer = document.getElementById("footer");
		if (footer) footer.classList.add("active");
		const dropback = document.getElementById("dropback");
		if (dropback) dropback.classList.add("active");
	};

	const closeFooterMenu = () => {
		const footer = document.getElementById("footer");
		if (footer) footer.classList.remove("active");
		const dropback = document.getElementById("dropback");
		if (dropback) dropback.classList.remove("active");
	};

	const closeFooter = () => {
		setOpenFooter(false);
		closeFooterMenu();
	};

	const handleChange = (newValue: string) => {
		if (newValue.startsWith("/")) {
			setNavigateTo(newValue);
			navigate(newValue, { replace: true });
			return;
		}
		if (data.getStationId()) {
			openFooterMenu();
			setOpenFooter(true);
		} else {
			enqueueSnackbar("請選擇旗站", { variant: "error" });
		}
	};

	const shouldHideScanButton = location.pathname === "/bag-list";

	return (
		<Box
			zIndex={1000}
			width={1}
			position={"fixed"}
			boxSizing={"border-box"}
			bottom={0}
			px={2.5}
			pb={2.5}
		>
			{
			!isMobile && (
				<BottomNavigation
					value={navigateTo}
					color="primary.light"
					onChange={(event, newValue) => handleChange(newValue)}
					sx={{
						height: 1,
						width: 1,
						py: 1,
						backgroundColor: "rgb(4, 3, 37)",
						borderRadius: "14px",

						"& .Mui-selected": {
							color: "primary.light",
						},
					}}
				>
					<BottomNavigationAction
						value="/"
						icon={<SpaceDashboard />}
					/>

					{!shouldHideScanButton && (
						<BottomNavigationAction
							icon={<Camera fontSize="large" />}
							value="camera"
						/>
					)}

					<BottomNavigationAction
						value="/setting"
						icon={<Settings />}
					/>
				</BottomNavigation>
			)
			}

		{isMobile && !shouldHideScanButton && (
			<Box display="flex" justifyContent="center" alignItems="center">
				<IconButton
					onClick={() => {
						if (data.getStationId()) {
							openFooterMenu();
							setOpenFooter(true);
						} else {
							enqueueSnackbar("請選擇旗站", { variant: "error" });
						}
					}}
					aria-label="掃描"
					sx={{
						backgroundColor: isOnline ? theme.palette.online_status.online : theme.palette.online_status.offline,
						borderRadius: "50%",
						width: 56,
						height: 56,
						boxShadow: 3,
						transition: "background-color 0.2s, box-shadow 0.2s",
						"&:hover": {
							backgroundColor: isOnline ? theme.palette.online_status.online : theme.palette.online_status.offline,
							boxShadow: 6,
						},
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<ScanComponent />
				</IconButton>
			</Box>
		)}

			<ScanMenu onClose={closeFooter} />
		</Box>
	);
};

export default NavigationtBar;
